export const ROUTE_PATH = '/stores/:storeId';

export const REDIRECT_ROUTE_PATH = '/reconciliation-history/store[eq]=:storeId';
